/* =========================================================
   mc-page-vari.js
   Variable Seite MC – Konsolidiertes JavaScript
   Version: 3.1 – Optimiert & Abgeschirmt
   
   Features:
   - Externe Links mit rel/target
   - GA4 Events fuer CTA und Content Links
   - Glossar Akkordeon
   - Bildoptimierung (lazy + async)
   - Darkmode-Schalter mit localStorage
   - Inhaltsverzeichnis (TOC) aus H2/H3
   - Smooth Scroll
   - Section-ID basierte Selektoren
   ========================================================= */

(function () {
  'use strict';

  var STORAGE_KEY = 'mcPageVariTheme';
  var SCROLL_OFFSET = 100;

  /* ---------------------------------------------------------
     Helper: DOM Ready
     --------------------------------------------------------- */
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---------------------------------------------------------
     Helper: Slugify fuer saubere IDs
     --------------------------------------------------------- */
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\u00e4/g, 'ae')
      .replace(/\u00f6/g, 'oe')
      .replace(/\u00fc/g, 'ue')
      .replace(/\u00df/g, 'ss')
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* ---------------------------------------------------------
     Externe Links
     --------------------------------------------------------- */
  function enhanceExternalLinks(section) {
    var relBase = section.getAttribute('data-external-rel-base') || 'noopener noreferrer';
    var nofollow = section.getAttribute('data-external-nofollow') === 'true';
    var relFull = nofollow && relBase.indexOf('nofollow') === -1 ? relBase + ' nofollow' : relBase;
    var host = window.location.hostname;
    var links = section.querySelectorAll('.mc-page-vari__rte a[href^="http"]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      try {
        var linkHost = new URL(link.href).hostname;
        if (linkHost && linkHost !== host) {
          link.setAttribute('rel', relFull);
          if (!link.hasAttribute('target')) {
            link.setAttribute('target', '_blank');
          }
        }
      } catch (e) {
        // Invalid URL, skip
      }
    }
  }

  /* ---------------------------------------------------------
     Bildoptimierung
     --------------------------------------------------------- */
  function enhanceImages(section) {
    var imgs = section.querySelectorAll('.mc-page-vari__rte img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
      if (!img.hasAttribute('fetchpriority')) {
        img.setAttribute('fetchpriority', 'low');
      }
    }
  }

  /* ---------------------------------------------------------
     Glossar Akkordeon
     --------------------------------------------------------- */
  function setupGlossary(section) {
    var glossaries = section.querySelectorAll('dl.mc-glossary');
    if (!glossaries.length) return;

    for (var g = 0; g < glossaries.length; g++) {
      var dl = glossaries[g];
      var children = [];
      for (var c = 0; c < dl.children.length; c++) {
        children.push(dl.children[c]);
      }
      
      var currentItem = null;

      for (var i = 0; i < children.length; i++) {
        var node = children[i];
        
        if (node.tagName === 'DT') {
          currentItem = document.createElement('div');
          currentItem.className = 'mc-glossary__item';

          var term = document.createElement('div');
          term.className = 'mc-glossary__term';
          term.setAttribute('role', 'button');
          term.setAttribute('tabindex', '0');
          term.innerHTML = node.innerHTML + '<span class="mc-glossary__term-icon" aria-hidden="true">\u203A</span>';

          currentItem.appendChild(term);
          dl.insertBefore(currentItem, node);
          dl.removeChild(node);

          (function(item, termEl) {
            termEl.addEventListener('click', function () {
              item.classList.toggle('is-open');
            });

            termEl.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                item.classList.toggle('is-open');
              }
            });
          })(currentItem, term);

        } else if (node.tagName === 'DD' && currentItem) {
          var def = document.createElement('div');
          def.className = 'mc-glossary__definition';
          def.innerHTML = node.innerHTML;
          currentItem.appendChild(def);
          dl.removeChild(node);
        }
      }
    }
  }

  /* ---------------------------------------------------------
     GA4 Events
     --------------------------------------------------------- */
  function setupGA4(section) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    if (section.getAttribute('data-enable-ga4') !== 'true') return;

    var sectionId = section.getAttribute('data-section-id') || 'unknown';

    // CTA Buttons
    var ctas = section.querySelectorAll('.mc-page-vari__cta .element-button, .mc-page-vari__cta > a');
    for (var i = 0; i < ctas.length; i++) {
      (function(btn) {
        btn.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'mc_cta_click',
            mc_cta_label: btn.textContent.trim(),
            mc_cta_href: btn.getAttribute('href') || null,
            mc_section_id: sectionId,
            mc_location: 'page-variable'
          });
        });
      })(ctas[i]);
    }

    // Content Links
    var links = section.querySelectorAll('.mc-page-vari__rte a[href]');
    for (var j = 0; j < links.length; j++) {
      (function(link) {
        link.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'mc_content_link_click',
            mc_link_href: link.getAttribute('href'),
            mc_link_text: link.textContent.trim(),
            mc_section_id: sectionId,
            mc_location: 'page-variable'
          });
        });
      })(links[j]);
    }
  }

  /* ---------------------------------------------------------
     Darkmode Theme Toggle
     --------------------------------------------------------- */
  function applyTheme(section, theme) {
    var validTheme = (theme === 'dark') ? 'dark' : 'light';
    section.setAttribute('data-mc-theme', validTheme);
    
    var btn = section.querySelector('.mc-page-vari__theme-toggle');
    if (btn) {
      var isDark = validTheme === 'dark';
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      btn.textContent = isDark ? 'Light Mode' : 'Dark Mode';
    }
  }

  function getInitialTheme() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark' || stored === 'light') {
        return stored;
      }
    } catch (e) {
      // localStorage not available
    }
    
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }

  function setupThemeToggle(section, allSections) {
    var btn = section.querySelector('.mc-page-vari__theme-toggle');
    if (!btn) return;

    var initialTheme = getInitialTheme();
    
    for (var i = 0; i < allSections.length; i++) {
      applyTheme(allSections[i], initialTheme);
    }

    btn.addEventListener('click', function () {
      var currentTheme = section.getAttribute('data-mc-theme');
      var nextTheme = currentTheme === 'dark' ? 'light' : 'dark';

      for (var j = 0; j < allSections.length; j++) {
        applyTheme(allSections[j], nextTheme);
      }

      try {
        window.localStorage.setItem(STORAGE_KEY, nextTheme);
      } catch (e) {
        // localStorage not available
      }
    });
  }

  /* ---------------------------------------------------------
     Inhaltsverzeichnis (TOC)
     --------------------------------------------------------- */
  function initTOC(section) {
    var toc = section.querySelector('.mc-page-vari__toc');
    if (!toc) return;

    var list = toc.querySelector('.mc-page-vari__toc-list');
    var toggle = toc.querySelector('.mc-page-vari__toc-toggle');
    var sectionId = section.getAttribute('data-section-id') || '';
    var content = section.querySelector('[id^="mc-page-rte"]');
    
    if (!list || !toggle || !content) return;

    var headings = content.querySelectorAll('h2, h3');
    
    if (!headings.length) {
      toc.style.display = 'none';
      return;
    }

    var usedIds = {};

    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var level = heading.tagName === 'H2' ? 2 : 3;
      var text = heading.textContent.trim();
      if (!text) continue;

      var baseId = heading.id || slugify(text);
      var id = baseId;
      
      if (usedIds[id]) {
        usedIds[id]++;
        id = baseId + '-' + usedIds[id];
      } else {
        usedIds[id] = 1;
      }
      
      heading.id = id;

      var li = document.createElement('li');
      li.setAttribute('data-level', String(level));

      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;

      li.appendChild(a);
      list.appendChild(li);
    }

    if (!list.children.length) {
      toc.style.display = 'none';
      return;
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      
      if (expanded) {
        toggle.setAttribute('aria-expanded', 'false');
        toc.classList.remove('is-open');
        setTimeout(function () {
          list.hidden = true;
        }, 260);
      } else {
        list.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toc.classList.add('is-open');
      }
    });

    list.addEventListener('click', function (e) {
      var target = e.target;
      if (target.tagName !== 'A') return;
      
      var href = target.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;

      var targetId = href.slice(1);
      var targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      e.preventDefault();
      
      var top = targetEl.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
      
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      if (history.replaceState) {
        history.replaceState(null, '', href);
      }
    });
  }

  /* ---------------------------------------------------------
     Back to Top Smooth Scroll
     --------------------------------------------------------- */
  function setupBackToTop(section) {
    var backLink = section.querySelector('.mc-page-vari__back a');
    if (!backLink) return;

    backLink.addEventListener('click', function (e) {
      var href = backLink.getAttribute('href');
      if (!href || href.indexOf('#mc-page-vari-') !== 0) return;

      e.preventDefault();
      
      var targetEl = document.getElementById(href.slice(1));
      if (targetEl) {
        var top = targetEl.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

      if (history.replaceState) {
        history.replaceState(null, '', href);
      }
    });
  }

  /* ---------------------------------------------------------
     Initialisierung
     --------------------------------------------------------- */
  ready(function () {
    var sections = document.querySelectorAll('section.mc-page-vari[data-mc-scope="true"]');
    if (!sections.length) return;

    var sectionsArray = [];
    for (var i = 0; i < sections.length; i++) {
      sectionsArray.push(sections[i]);
    }

    for (var j = 0; j < sectionsArray.length; j++) {
      var section = sectionsArray[j];
      enhanceExternalLinks(section);
      enhanceImages(section);
      setupGlossary(section);
      setupGA4(section);
      initTOC(section);
      setupBackToTop(section);
    }

    for (var k = 0; k < sectionsArray.length; k++) {
      setupThemeToggle(sectionsArray[k], sectionsArray);
    }
  });

})();